import type { FormatMessageResponse } from 'stream-chat';

export const latestMessageUserId = (messages: FormatMessageResponse[]) => {
  const messageLatest = messages[messages.length - 1];
  return messageLatest?.user?.id;
};
